import axios from "axios";
import JwtService from "@/core/services/jwt.service";
import urlBackEnd from "../../helpers/url";


/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    axios.defaults.baseURL = urlBackEnd('/api/v1');
    //axios.defaults.baseURL = 'https://sun-be.market/api-serve/public/api/v1';
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  /**
   *
   * @param resource
   * @param slug
   * @param params
   * @returns {*}
   */

  store(resource, slug, params) {
    return axios.post(`${resource}/${slug}`, params);
  },

  /**
   *
   * @param resource
   * @param params
   * @returns {*}
   */

  query(resource, params) {
    return axios.get(`${resource}`, params);
  },



  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */



  get(resource, slug = "") {
    if (slug){
      return axios.get(`${resource}/${slug}`);
    } else {
      return axios.get(`${resource}`);
    }
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return axios.post(`${resource}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @param id
   * @returns {*}
   */

  delete(resource, id = "") {
    if (id){
      return axios.delete(`${resource}/${id}`);
    } else {
      return axios.delete(`${resource}`);
    }

  }
};

export default ApiService;
